export function isFullUser(user) {
    return 'screen_name' in user;
}
